export default __webpack_public_path__ + "static/media/The-Three-bakers-cyprus.c9d56f5a.png";